<!-- 个人采购订单 -->
<template>
   <div class='page_content'>
      <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false"
         append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
         <purchaseOrderAction v-if="showStatus" ref="purchaseOrderAction" @drawerCancel="drawerCancel"
            @toDetail="toDetail" :actionData="actionData"></purchaseOrderAction>
      </el-drawer>
      <subComponents ref="showSelectData"></subComponents>
      <div class="page_content_top">
         <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo"
            @openFormDesign="openFormDesign"></v-button>
         <div class="page_content_top_line">
            <v-search v-if="pageShowData.jurHead" :flagList="['woamSalesman']"
               :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData"
               @searchData="searchData" @openSearch="openSearch">

            </v-search>

         </div>
      </div>

      <div class="page_content_center">
         <el-table v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight"
            :key="$store.state.tableNum" border style="width: 100%" @selection-change="handleSelectionChange"
            highlight-current-row size="mini">
            <el-table-column type="selection" width="40">
            </el-table-column>
            <!-- 主表格 -->
            <el-table-column align="center" :sortable="tableValye.isSort == 1" v-if="tableValye.isShow == 1"
               v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey"
               show-overflow-tooltip :prop="tableValye.entityField" :min-width="tableValye.fieldWeight"
               :label="tableValye.showField">
               <template slot-scope="scope">
                  <el-tag size="mini" v-if="tableValye.entityField == 'isWms'">
                     {{ scope.row.isWms == 0 ? '否' : '是' }}
                  </el-tag>
                  <!-- <span v-else-if="tableValye.fieldType == 'date'">
              <span v-if="scope.row[tableValye.entityField]">
                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
              </span>
            </span> -->
                  <span v-else-if="tableValye.fieldType == 'date' && scope.row[tableValye.entityField]">
                     {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                  </span>
                  <span v-else-if="tableValye.fieldType == 'dateTime' && scope.row[tableValye.entityField]">
                     {{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}
                  </span>
                  <span v-else-if="tableValye.isRift == 1">
                     <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField] }}</a>
                  </span>
                  <span v-else>
                     {{ scope.row[tableValye.entityField] }}
                  </span>
               </template>
            </el-table-column>
         </el-table>
      </div>
      <div class="page_content_bottom">
         <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total"
            @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
      </div>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
         <SearchScheme ref="searchScheme" :id="seId" :smId="smId" :parentSearchData="parentSearchData"
            @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <!-- 合同 -->
      <el-dialog :title="'已上传' + upType" :visible.sync="diaContract" width="800px">
         <!-- <div>
        <el-button @click="openFile()" type="primary" icon="el-icon-upload" size="mini">上传文件</el-button>
      </div> -->
         <upDataFile v-if="diaContract" ref="upFile"></upDataFile>
         <div class="fileTable">
            <el-button class="btn" type="primary" size="mini" @click="batchDownLoad">批量下载</el-button>
            <el-table size="mini" :data="fileData" border style="width: 100%">
               <el-table-column prop="codingNum" show-overflow-tooltip label="编码">
               </el-table-column>
               <el-table-column prop="busType" show-overflow-tooltip label="业务类型">
               </el-table-column>
               <el-table-column prop="createrName" show-overflow-tooltip label="上传人">
               </el-table-column>
               <el-table-column prop="createTime" show-overflow-tooltip label="上传时间">
                  <template slot-scope="scope">
                     <span v-if="scope.row.createTime">
                        {{ $common.getLocalTime(scope.row.createTime) }}
                     </span>
                  </template>
               </el-table-column>
               <el-table-column prop="fileName" show-overflow-tooltip label="文件名">
               </el-table-column>
               <el-table-column prop="type" show-overflow-tooltip label="文件类型">
               </el-table-column>
               <el-table-column prop="fileUrl" show-overflow-tooltip label="附件">
                  <template slot-scope="scope">
                     <ul v-if="scope.row.fileUrl">
                        <li style="display: flex;align-items: center;flex-wrap: wrap; width: 31px;height: 31px;margin-right: 5px;"
                           v-for="(item, index) in scope.row.fileUrl.split(',')" :key="index">
                           <cusImage style="width: 30px;height: 30px;" :src="$common.getFileAddress(item)"
                              :preview-src-list="$common.getFileAddressARR(scope.row.fileUrl.split(','))">
                           </cusImage>
                        </li>
                     </ul>
                  </template>
               </el-table-column>
               <el-table-column width="160" label="操作">
                  <template slot-scope="scope">
                     <div class="imgs">
                        <el-link @click="downLoadFile(scope.row.fileUrl)" type="primary" :underline="false"
                           style="margin-left:10px">另存为</el-link>
                        <!-- <el-link @click="openFile(scope.row.codingNum,scope.row.fileId,scope.row,1)" type="success" :underline="false" style="margin-left:10px">修改</el-link> -->
                        <el-link @click="delFile(scope.row.fileId)" type="danger" :underline="false"
                           style="margin-left:10px">删除</el-link>
                     </div>
                  </template>
               </el-table-column>
            </el-table>
         </div>
      </el-dialog>
      <el-dialog :title="'查看' + upType" :visible.sync="diaContractSee" width="800px">
         <el-button type="primary" size="mini" @click="printImgs()" style="margin-bottom: 10px;">
            批量打印
         </el-button>
         <el-button type="primary" size="mini" @click="batchDownLoad()" style="margin-bottom: 10px;">
            批量下载
         </el-button>
         <div class="fileTable">
            <el-table size="mini" :data="fileData" border style="width: 100%">
               <el-table-column prop="codingNum" show-overflow-tooltip label="编码"></el-table-column>
               <el-table-column prop="busType" show-overflow-tooltip label="业务类型"></el-table-column>
               <el-table-column prop="createrName" show-overflow-tooltip label="上传人"></el-table-column>
               <el-table-column prop="createTime" show-overflow-tooltip label="上传时间">
                  <template slot-scope="scope">
                     <span v-if="scope.row.createTime">
                        {{ $common.getLocalTime(scope.row.createTime) }}
                     </span>
                  </template>
               </el-table-column>
               <el-table-column prop="fileName" show-overflow-tooltip label="文件名"></el-table-column>
               <el-table-column prop="fileType" show-overflow-tooltip label="文件类型"></el-table-column>
               <el-table-column prop="fileUrl" show-overflow-tooltip label="附件">
                  <template slot-scope="scope">
                     <ul v-if="scope.row.fileUrl">
                        <li style="display: flex;align-items: center;flex-wrap: wrap; width: 31px;height: 31px;margin-right: 5px;"
                           v-for="(item, index) in scope.row.fileUrl.split(',')" :key="index">
                           <cusImage style="width: 30px;height: 30px;" :src="$common.getFileAddress(item)"
                              :preview-src-list="$common.getFileAddressARR(scope.row.fileUrl.split(','))">
                           </cusImage>
                        </li>
                     </ul>
                  </template>
               </el-table-column>
               <el-table-column width="135" label="操作">
                  <template slot-scope="scope">
                     <div class="imgs">
                        <el-link @click="downLoadFile(scope.row.fileUrl)" type="primary" :underline="false"
                           style="margin-left:10px">另存为</el-link>
                     </div>
                  </template>
               </el-table-column>
            </el-table>
         </div>
      </el-dialog>
      <el-dialog title="批量打印" :visible.sync="diaImgs" width="990px">
         <el-button type="primary" @click="handlePrint" size="mini" style="margin-bottom:10px">打印</el-button>
         <div style="width: 967px;">
                <div v-for="(key, index) in fileData" :key="index" style="height: 1405px;width: 967px; position: relative; ">
                    <el-image v-if="key.flag" :style="`width: 1400px;height: 960px;transform: rotateZ(90deg);position: absolute;left:-217px;bottom:219px;`" :src="$common.getFileAddress(key.fileUrl)"
                              fit="contain"></el-image>
                    <el-image v-else :style="`width: 960px;height: 1400px;`" :src="$common.getFileAddress(key.fileUrl)" fit="contain"></el-image>
                    <div style="page-break-after: always;"></div>
                </div>
            </div>
      </el-dialog>
        <div id="print-container" style="display: none;"></div>
      <customDesign ref="customDesign"></customDesign>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import SearchScheme from "../../../byComponents/SearchScheme.vue";

import purchaseOrderAction from "@/components/purchaseOrderAction.vue";
//例如：import 《组件名称》 from '《组件路径》';
import print from 'vue-print-nb'
export default {
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
      purchaseOrderAction
   },
   data() {
      //这里存放数据
      return {
         tableHeight: 0,
         getRequestData: {
            psomBuycus: "",
            smName: "",
            page: 1,
            rows: 30,
            start:
               new Date(new Date().toLocaleDateString()).getTime() -
               31 * 24 * 3600 * 1000,
            end:
               new Date(new Date().toLocaleDateString()).getTime() +
               24 * 60 * 60 * 1000 -
               1,
            smId: "",
         },
         returnData: {
            pages: 0, // 总页数
            total: 0, // 总条数
            pageNum: 0, // 当前页数
            list: [],
         },
         buttonList: [],
         pageShowData: [],
         formDataList: [],
         selectedDataIndex: 0,
         seId: "",
         seTitle: "",
         seWidth: "",
         DialogVisible: false,
         seType: "",
         smId: "",
         showStatus: false,
         actionData: {},
         diaContract: false, //合同
         diaInspectionReport: false, // 检验报告
         diaInvoice: false, // 发票
         diaWithCar: false, // 随货同行
         multipleSelection: [],
         fileIds: [], //明细id数组 明细单号
         busynessKey: [], //记账单号
         fileData: [],
         diaTitle: '上传合同',
         upType: 1,
         url: require('@/assets/img/other/look.png'),
         srcList: [],
         requesUrl: '',
         imgUrl: '',
         parentSearchData: {},
         sField: "",
         diaContractSee: false,
         diaImgs: false,
         ormId: "",
         print: {
            id: 'imgs',
            popTitle: 'erp', // 打印配置页上方的标题
            extraHead: 'erp', // 最上方的头部文字，附加在head标签上的额外标签，使用逗号分割
            preview: true, // 是否启动预览模式，默认是false
            previewTitle: 'erp', // 打印预览的标题
            previewPrintBtnLabel: '预览结束，开始打印', // 打印预览的标题下方的按钮文本，点击可进入打印
            zIndex: 20002, // 预览窗口的z-index，默认是20002，最好比默认值更高
            previewBeforeOpenCallback() { console.log('正在加载预览窗口！'); console.log(that.msg, this) }, // 预览窗口打开之前的callback
            previewOpenCallback() { console.log('已经加载完预览窗口，预览打开了！') }, // 预览窗口打开时的callback
            beforeOpenCallback() { console.log('开始打印之前！') }, // 开始打印之前的callback
            openCallback() { console.log('执行打印了！') }, // 调用打印时的callback
            closeCallback() { console.log('关闭了打印工具！') }, // 关闭打印的callback(无法区分确认or取消)
            clickMounted() { console.log('点击v-print绑定的按钮了！') },
            standard: '',
            extarCss: '',
         },
         isPage: false,
      };
   },
   directives: {
      print
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      "getRequestData.smName": {
         handler: function (newValue, oldValue) {
            if (newValue == "") {
               this.getRequestData.smId = "";
            }
         },
         deep: true,
      },
      diaContract() {
         if (!this.diaContract) {
            this.$refs.upFile.fileList = []
            this.$refs.upFile.codingNum = ""
            this.getDataList()
         }
      },
   },
   //方法集合
   methods: {
      //--------------------------打印
      printImgs() {
         this.diaImgs = true
      },
      handlePrint() {
         if (!this.fileData.length) return
         this.$message({
            type: 'info',
            message: '正在加载图片，请稍候...',
            duration: 0
         })

         const loadImagePromises = this.fileData.map(item => {
            return new Promise((resolve, reject) => {
               const img = new Image()
               const imgSrc = this.$common.getFileAddress(item.fileUrl)
               img.onload = () => resolve({ item, img, imgSrc })
               img.onerror = () => reject(new Error(`图片加载失败: ${imgSrc}`))
               img.src = imgSrc
            })
         })

         Promise.all(loadImagePromises)
            .then(loadedImages => {
               this.$message.closeAll()

               let printContent = '<!DOCTYPE html><html><head><meta charset="UTF-8"><title>批量打印</title>'
               printContent += '<style>'
               printContent += '@page { margin: 5mm; size: auto; }'
               printContent += '* { margin: 0; padding: 0; box-sizing: border-box; }'
               printContent += 'html, body { margin: 0; padding: 0; width: 100%; height: 100%; }'
               printContent += '.print-page { page-break-after: always; page-break-inside: avoid; width: 100%; height: 100vh; min-height: 100vh; display: flex; justify-content: center; align-items: center; overflow: visible; position: relative; }'
               printContent += '.print-page.last-page { page-break-after: avoid; }'
               printContent += '.print-page img { display: block; max-width: 100%; max-height: 100%; width: auto; height: auto; object-fit: contain; }'
               printContent += '.print-page img.rotate-img { position: absolute; top: 50%; left: 50%; max-width: calc(100vh - 10mm); max-height: calc(100vw - 10mm); transform: translate(-50%, -50%) rotate(90deg); }'
               printContent += '.page-num { position: absolute; right: 12px; bottom: 10px; z-index: 10; font-size: 14px; color: #000; font-family: Arial, sans-serif; background: rgba(255,255,255,0.75); padding: 2px 8px; border-radius: 2px; }'
               printContent += '</style></head><body>'

               const totalPages = loadedImages.length
               loadedImages.forEach(({ img, imgSrc }, index) => {
                  const isLast = index === totalPages - 1
                  const pageClass = isLast ? 'print-page last-page' : 'print-page'
                  const nw = img.naturalWidth || 1
                  const nh = img.naturalHeight || 1
                  const needRotate = nw > nh
                  const imgClass = needRotate ? 'rotate-img' : ''
                  printContent += `<div class="${pageClass}">`
                  printContent += `<img class="${imgClass}" src="${imgSrc}" alt="" />`
                  if (this.isPage) {
                     printContent += `<div class="page-num">${index + 1} / ${totalPages}</div>`
                  }
                  printContent += '</div>'
               })

               printContent += '</body></html>'

               const printWindow = window.open('', '_blank')
               if (!printWindow) {
                  this.$message.error('浏览器阻止了弹出窗口，请允许弹出窗口后重试')
                  return
               }

               printWindow.document.write(printContent)
               printWindow.document.close()
               printWindow.onload = () => {
                  setTimeout(() => {
                     printWindow.print()
                     printWindow.close()
                     this.diaImgs = false
                     this.diaContractSee = false
                  }, 500)
               }
            })
            .catch(error => {
               this.$message.closeAll()
               this.$message.error('图片加载失败: ' + error.message)
            })
      },
      //--------------------------------------
      //   下载文件
      downLoadFile(e) {
         window.location.href = this.requesUrl + '/psaccount/downDetailFile?url=' + e
      },
      //批量下载
      batchDownLoad() {
         const url = `${this.requesUrl}/psaccount/downFileZip?busynessId=${encodeURIComponent(this.fileIds.toString())}&busynessType=${encodeURIComponent(this.upType)}`
         const form = document.createElement('form')
         form.method = 'POST'
         form.action = url
         form.style.display = 'none'
         document.body.appendChild(form)
         form.submit()
         document.body.removeChild(form)
      },
      //   删除文件
      async delFile(e, type) {
         if (type) {
            let params = {
               ids: [e]
            }
            let responseData = await this.$http.delFile(params);
            if (responseData.status == 200) {
               this.getFileListByIds()
               this.$refs.upFile.fileList = []
               this.$refs.upFile.codingNum = ""
            }
            return
         }
         this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         }).then(async () => {
            let params = {
               ids: [e]
            }
            let responseData = await this.$http.delFile(params);
            if (responseData.status == 200) {
               this.$message({
                  type: "success",
                  message: "删除成功!",
               });
               this.$refs.upFile.fileList = []
               this.$refs.upFile.codingNum = ""
               this.getFileListByIds()
            } else {
               this.$message({
                  message: responseData.message,
                  type: "error",
               });
            }
         }).catch(() => { });
      },
      //  打开文件上传组件
      openFile(codingNum, field, row, type) {
         this.$refs['upFile'].openFileDia(codingNum, field, row, type)
      },
      //多选
      handleSelectionChange(val) {
         this.multipleSelection = val;
      },
      // 子组件触发
      drawerCancel(e) {
         this.showStatus = false;
         if (e == 1) this.getDataList();
      },
      // 点击穿透字段 传参单号
      toDetail(orderId) {
         if (orderId) {
            // 设置为true 打开穿透组件首页
            var isPenetrate = true;
            // 设置缓存 存入点击单号
            this.resetSetItem("penetrateOrderId", orderId);
            // 与父级跨域通信 传递isPenetrate参数
            window.parent.postMessage(
               {
                  //向窗口发送MessageEvent消息
                  cmd: "returnFormJson",
                  params: { isPenetrate }, //参数
               },
               "*"
            );
         }
      },
      changeInputModel(val) {
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            this.getRequestData.smName = val.smName;
            this.getRequestData.smId = val.smId;
            this.paramValue(val)
         }
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(',')
         arr.forEach(item => {
            this.getRequestData[item] = val[item]
         })
      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },

      // 检索Id, 索引(表格中), 标识
      openSearch({ sId, index, type, sField }) {
         this.DialogVisible = true;
         this.seId = sId;
         this.sField = sField
         this.parentSearchData[type] = this.getRequestData[type]
      },

      // 获取数据列表
      async getPageInfo() {
         var pathId = parent.getMenuInfo(this.$route.path);
         let responseData = await this.$http.getJur({
            ids: [pathId.jurId]
         });
         if (responseData.status == 200) {
            this.pageShowData = responseData.result;
            this.formDataList = this.pageShowData.jurFormVoList;
            var obj = {}
            if (this.pageShowData.jurHead) {
               obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
            } else {
               obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
            }
            for (const key in obj) {
               this.$set(this.getRequestData, key, obj[key])
            }
            this.getDataList();
            this.getButtonList();
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      // 动作集合
      actionSet(actionData) {
         if (this.multipleSelection.length == 0 && actionData.actionType != 15) {
            this.$message({
               message: "请先选中要操作的数据",
               type: "error",
            });
            return false;
         }
         switch (actionData.actionType) {
            case 11:
               this.upType = '合同'
               this.ormId = ''
               this.getFileListByIds()
               break;
            case 12:
               this.upType = '检验报告'
               this.ormId = JSON.parse(sessionStorage.getItem('ormId'))
               this.getFileListByIds()
               break;
            case 16:
               this.upType = '检验报告'
               this.ormId = ''
               this.getFileListByIds(true)
               break;
            case 13:
               this.upType = '发票'
               this.ormId = ''
               this.getFileListByIds()
               break;
            case 14:
               this.upType = '随货同行'
               this.ormId = ''
               this.getFileListByIds()
               break;
            case 18:
               this.upType = '物流单'
               this.ormId = ''
               this.getFileListByIds()
               break;
            case 15:

               this.exportData()
               break;
         }
      },
      openFormDesign() {
         let pathInfo = parent.getMenuInfo(this.$route.path)
         this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
      },
      exportData() {
         window.location.href =
            this.requesUrl +
            "/psaccount/exportPsbkDetailVo?psomBuycus=" + this.getRequestData.psomBuycus + "&start=" +
            this.getRequestData.start + "&end=" +
            this.getRequestData.end + "&smName=" +
            this.getRequestData.smName + "&smId=" +
            this.getRequestData.smId + "&batchno=" +
            this.getRequestData.batchno + "&bgmName=" +
            this.getRequestData.bgmName + "&isFp=" +
            this.getRequestData.isFp + "&isHt=" +
            this.getRequestData.isHt + "&isJybb=" +
            this.getRequestData.isJybb + "&isShtx=" +
            this.getRequestData.isShtx + "&psbkmId=" +
            this.getRequestData.psbkmId + "&ormId=" +
            JSON.parse(sessionStorage.getItem('ormId'))

      },
      // 通过明细id查询文件列表
      async getFileListByIds(flag) {
         this.fileIds = []
         this.busynessKey = []
         this.multipleSelection.forEach(item => {
            this.fileIds.push(item.psbkdId)
            this.busynessKey.push(item.psbkmId)
         })
         let params = {
            busynessId: this.fileIds.toString(),
            fileType: this.upType
         }
         let responseData = await this.$http.queryFileListByIds(params);
         if (responseData.status == 200) {
            this.fileData = responseData.result.list
            if (flag) {
               this.fileData.forEach(item => {
                  const src = this.imgUrl + '/' + item.fileUrl
                  const img = new Image();
                  img.src = src
                  img.onload = () => {
                     if (img.width > img.height) {
                        item.flag = true
                     } else {
                        item.flag = false
                     }
                  };
               })
            }
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
         if (flag) {
            this.diaContractSee = true
         } else {
            this.diaContract = true
         }
      },
      showPrintPlan() {
         var dataInfo = this.returnData.list[this.selectedDataIndex];
         if (!dataInfo) {
            this.$message({
               message: "请先选中要操作的数据",
               type: "error",
            });
            return false;
         }
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据
            var info = this.returnData.list[this.selectedDataIndex];
            this.$refs.printPlan.openDia(info.psomId);
         } else {
            return;
         }
      },
      // 数据搜索
      searchData() {
         this.getRequestData.page = 1;
         this.getDataList();
      },
      // 数据翻页
      setDataPageNumber(val) {
         this.getRequestData.page = val;
         this.getDataList();
      },

      // 切换显示条数
      setDataPageSize(val) {
         this.getRequestData.page = 1;
         this.getRequestData.rows = val;
         this.getDataList();
      },

      // 获取数据列表
      async getDataList() {
         let responseData = await this.$http.queryFileList(
            this.getRequestData
         );
         if (responseData.status == 200) {
            this.returnData.list = responseData.result.list;
            this.returnData.pages = responseData.result.pages;
            this.returnData.total = responseData.result.total;
            this.returnData.pageNum = responseData.result.pageNum;
            this.selectedDataIndex = 0;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      // 删除数据
      delDataAction() {
         var dataInfo = this.returnData.list[this.selectedDataIndex];
         if (!dataInfo) {
            this.$message({
               message: "请先选中要操作的数据",
               type: "error",
            });
            return false;
         }

         this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(async () => {
               var delData = {
                  ids: [dataInfo.psomId],
               };
               let responseData = await this.$http.delPurchaseOrder(delData);
               if (responseData.status == 200) {
                  this.$message({
                     type: "success",
                     message: "删除成功!",
                  });

                  this.getDataList();
               } else {
                  this.$message({
                     message: responseData.message,
                     type: "error",
                  });
               }
            })
            .catch(() => { });
      },

      async getButtonList() {
         this.buttonList = await this.$common.getActionButton();
         console.log(this.buttonList)
      },
      //获取图片存取的根路径
      imgurl() {
         // console.log(this.$store.getters.getConfig);
         this.requesUrl = this.$store.getters.getConfig.requestUrl;
         this.imgUrl = this.$store.getters.getConfig.imgUrl;
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.imgurl()
      this.getPageInfo();
      this.isPage = window.global_config.isPage || false
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
   margin-right: 1rem;
}

.el-tabs--border-card_new {
   height: 85vh;
   overflow-y: scroll;
}

.el-drawer {
   outline: none;
}

.fileTable {
   position: relative;
   margin-top: 10px;
}

.btn {
   position: absolute;
   top: -45px;
   right: 0;
}

.el-link {
   font-size: 12px !important;
}

.imgs {
   display: flex;
   align-items: center;
}

::v-deep.el-image img {
   margin-top: 2px;
}
</style>